<template>
  <v-container fluid>
    <div class="main">

      <div class="text-end mb-3">
        <v-btn color="gifty"
               dark
               class="rounded-lg"
               depressed
               @click="addItem"
        >
          <v-icon left>mdi-plus</v-icon>
          Ajouter
        </v-btn>
      </div>

      <v-overlay :value="overlay" absolute color="white" opacity="0.5">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-row>
        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              <div>
                <v-text-field hide-details
                              v-model="keyword"
                              rounded
                              filled
                              dense
                              append-icon="mdi-magnify"
                              single-line
                              clearable
                              placeholder="Rechercher..."
                              v-on:keyup.enter="fetchData"
                />
              </div>
            </v-card-title>

            <v-divider/>

            <v-card-text class="pa-0">

              <div v-if="isLoading">
                <v-skeleton-loader type="table"></v-skeleton-loader>
              </div>

              <div v-else>
                <v-data-table :headers="headers"
                              :items="campaigns"
                              :search="keyword"
                >

                  <template v-slot:item.status="{ item }">
                    <v-switch v-model="item.is_active"
                              class="pa-0 ma-0"
                              color="success"
                              hide-details
                              readonly
                              @click="changeStatus(item.id)"></v-switch>

                  </template>


                  <template v-slot:item.boostings="{ item }">
                    <v-chip v-for="(b,i) in item.boostings"
                            :key="i"
                            class="mx-1 my-1"
                            :style="{ background: 'rgba(214,12,86,0.12)', color: '#d60c56' }"
                    >
                      <v-icon left small color="gifty">mdi-rocket-launch-outline</v-icon>
                      {{ b.name }}
                    </v-chip>

                  </template>

                  <template v-slot:item.name="{ item }">
                    <span class="text-no-wrap">
                       {{ item.name }}
                    </span>
                  </template>

                  <template v-slot:item.home_banner_image="{ item }">
                    <v-avatar size="45" rounded class="my-3">
                      <v-img :src="FILE_URL + item.home_banner_image"></v-img>
                    </v-avatar>
                  </template>

                  <template v-slot:item.start_date="{ item }">
                    <v-chip
                        :style="{ background: 'rgba(25,233,18,0.12)', color: '#19e912' }"
                    >
                      <v-icon left small color="success">mdi-calendar-start</v-icon>
                      {{ item.start_date }}
                    </v-chip>
                  </template>


                  <template v-slot:item.end_date="{ item }">
                    <v-chip
                        :style="{ background: 'rgba(233,18,18,0.12)', color: '#e91212' }"
                    >
                      <v-icon left small color="error">mdi-calendar-end</v-icon>
                      {{ item.end_date }}
                    </v-chip>
                  </template>

                  <template v-slot:item.is_default="{ item }">
                    <v-icon v-if="item.is_default" color="success">mdi-check-circle</v-icon>
                    <v-icon v-else color="red">mdi-close-circle</v-icon>
                  </template>

                  <template v-slot:item.users_count="{ item }">
                    <v-chip v-if="item.users_count"
                            :style="{ background: 'rgba(25,233,18,0.12)', color: '#19e912' }"
                    >
                      <v-icon left small color="success">mdi-account-check</v-icon>
                      {{ item.users_count }}
                    </v-chip>
                    <span v-else>-</span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <div class="d-flex align-center">
                      <v-btn icon @click="updateItem(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon @click="remove(item.id)">
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                      <v-btn icon @click="openGifts(item)">
                        <v-icon>mdi-gift-outline</v-icon>
                      </v-btn>
                    </div>
                  </template>

                </v-data-table>


              </div>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <AddDialog ref="addDialog" @refresh="fetchData" :boostings="boostings"/>
      <GiftsDialog ref="giftsDialog"/>

    </div>
  </v-container>
</template>

<script>
import AddDialog from "./components/AddDialog.vue";
import GiftsDialog from "./components/GiftsDialog.vue";

import {HTTP} from "@/http-common";

export default {
  components: {
    AddDialog,
    GiftsDialog,
  },
  data() {
    return {
      FILE_URL: process.env.VUE_APP_FILE_URL,
      isLoading: false,
      overlay: false,
      delete_id: null,
      keyword: null,
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Boostes',
          value: 'boostings',
        },
        {
          text: 'Clé',
          value: 'tracking_key',
        },
        {
          text: 'Nom',
          value: 'name',
        },
        {
          text: 'Banner',
          value: 'home_banner_image',
        },
        {
          text: 'Début',
          value: 'start_date',
        },
        {
          text: 'Fin',
          value: 'end_date',
        },
        {
          text: 'Tout le monde',
          value: 'is_default',
        },
        {
          text: 'Utilisateurs',
          value: 'users_count',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      campaigns: [],
      boostings: [],
    };
  },
  methods: {
    fetchData() {
      this.isLoading = true
      HTTP.get('/v1/boosting-methods').then(res => {
        this.campaigns = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    addItem() {
      this.$refs.addDialog.open();
    },
    updateItem(item) {
      this.$refs.addDialog.edit(item);
    },
    openGifts(item) {
      this.$refs.giftsDialog.open(item.id, item.gift_type);
    },
    remove(id) {
      this.delete_id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/boosting-methods/delete", {
        id: this.delete_id,
      }).then(() => {
        this.overlay = false;
        let i = this.campaigns.findIndex((el) => el.id === this.delete_id);
        this.$delete(this.campaigns, i);
        this.delete_id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/boosting-methods/change-status", {
        id: id,
      }).then(() => {
        this.overlay = false;
        let index = this.campaigns.findIndex(el => el.id === id)
        this.campaigns[index].is_active = !this.campaigns[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    getBoostingsList() {
      HTTP.get('/v1/boosting-methods/boostings-list').then(res => {
        this.boostings = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
  },
  mounted() {
    this.fetchData();
    this.getBoostingsList();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
  },
}
</script>

<style>
</style>